import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=65784c7f"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports